import * as React from 'react'
import { Container, InputElement, InputContainer, ErrorIcon } from './styled'
import { images } from '../../theme'

export interface InputElem {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  type?: string
  backgroundColor?: string
  errorBackgroundColor?: string
  placeholderColor?: string
  color?: string
  activeColor?: string
  placeholder?: string
  autocomplete?: 'off'
  autocorrect?: 'off'
  autocapitalize?: 'off'
  spellcheck?: boolean
  isError?: boolean
  value?: string | number
}
interface InputProps extends InputElem {}
export const Input: React.FC<InputProps> = ({
  onChange,
  isError = false,
  spellcheck = false,
  ...inputProps
}) => (
  <Container>
    <InputContainer>
      <InputElement
        onChange={onChange}
        isError={isError}
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck={spellcheck}
        {...inputProps}
      />
      {isError && <ErrorIcon title={'Error icon'} src={images.alertCircle} />}
    </InputContainer>
  </Container>
)
